import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $clientCount,
  getClientCount,
  clientCountMounted,
  getClientCountByDay,
  $clientCountByDay,
} from './model'

export const useClientCountWidget = () => {
  React.useEffect(() => {
    clientCountMounted()
  }, [])

  const clientCount = useStore($clientCount)
  const loading = useStore(getClientCount.pending)

  return {
    clientCount,
    loading,
  }
}

export const useClientCountByDay = () => {
  React.useEffect(() => {}, [])

  const clientCountByDay = useStore($clientCountByDay)
  const loading = useStore(getClientCountByDay.pending)

  return {
    clientCountByDay,
    loading,
  }
}
